import { useState, type ReactNode } from "react";

/**
 * Ruhende Seite mit eigenem Abruf (Live, Qualität, Tests): lädt nichts,
 * bis jemand ausdrücklich "Einmal laden" wählt. Der Ruhehinweis selbst
 * kommt aus dem Layout.
 */
export function RuhendGate({ title, children }: { title: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  if (open) return <>{children}</>;
  return (
    <section className="lt-gate" aria-label={title}>
      <h1>{title}</h1>
      <p>Diese Seite fragt nichts ab, solange die eigene Sprachstrecke ruht.</p>
      <button type="button" className="btn btn-secondary" onClick={() => setOpen(true)}>
        Einmal laden
      </button>
    </section>
  );
}
